import React, { useMemo } from "react";
import useAllPlayers from "../../../hooks/queryResults/useAllPlayers";
import useQueriesAreLoading from "../../../hooks/queryResults/useQueriesAreLoading";
import useSiteRankings from "../../../hooks/queryResults/useSiteRankings";
import Util from "../../../util/util";
import Table from "../../layout/Table";
import Loading from "../../ui/Loading";

export default function AdminListsRankings() {
  const season = Util.getCurrentSeason();
  const { siteRankingsData, siteRankingsQuery } = useSiteRankings();
  const { playersData, playersQuery } = useAllPlayers();

  const isLoading =
    useQueriesAreLoading([siteRankingsQuery, playersQuery]) ||
    !(siteRankingsData && playersQuery);

  const tableColumns = useMemo(
    () => [
      {
        Header: "Rank",
        accessor: "rank",
      },
      {
        Header: "Pos",
        accessor: "pos",
      },
      {
        Header: "First",
        accessor: "firstName",
        className: "left",
      },
      {
        Header: "Last",
        accessor: "lastName",
        className: "left",
      },
      {
        Header: "NFL",
        accessor: "nflTeamAbbr",
      },
    ],
    []
  );

  let entries = null;
  let players = null;
  if (!isLoading) {
    entries = siteRankingsData.playerList.entries;
    players = playersData.players;
  }

  const tableData = useMemo(() => {
    if (!(entries && players)) return [];

    return Object.keys(entries).map((rank) => {
      const playerId = entries[rank];
      const player = players[playerId];
      const { pos, firstName, lastName, nflTeamAbbr } = player;

      return {
        rank,
        pos,
        firstName,
        lastName,
        nflTeamAbbr,
      };
    });
  }, [entries, players]);

  return isLoading ? (
    <Loading />
  ) : (
    <div>
      <h1>{season} Site Rankings</h1>
      <Table columns={tableColumns} data={tableData} />
    </div>
  );
}
